import { createContext, ReactNode, useContext, useMemo } from 'react';

interface AccordionGroupContextProps {}

const AccordionGroupContext = createContext<AccordionGroupContextProps | undefined>(undefined);

export function useAccordionGroupContext() {
  const context = useContext(AccordionGroupContext);
  if (!context) {
    throw new Error('Using Accordion outside Accordion group is not allowed');
  }

  return context;
}

function useAccordionGroupContextProviderVM() {
  return useMemo(() => ({}), []);
}

export interface AccordionGroupContextProviderProps {
  children: ReactNode;
}

/**
 * This context provider is just used for safety
 * that throws an error when you try to use Accordion outside AccordionGroup
 * */
export function AccordionGroupContextProvider({ children }: AccordionGroupContextProviderProps) {
  const value = useAccordionGroupContextProviderVM();
  return <AccordionGroupContext.Provider value={value}>{children}</AccordionGroupContext.Provider>;
}
